<template>
  <div class="expanded-wrapper">
    <BetslipBody
      :bettingLocked="bettingLocked"
      :theme="theme"
      :payinDisabled="disabled"
      :predefinedStakes="predefinedStakes"
      :bettingDisabled="bettingDisabled"/>
    <div class="footer">
      <BetslipFooter
        :bettingLocked="bettingLocked"
        :payinDisabled="disabled"
        :predefinedStakes="predefinedStakes"
        :bettingDisabled="bettingDisabled"/>
    </div>
  </div>
</template>

<script>
import BetslipBody from './BetslipBody';
import BetslipFooter from './BetslipFooter';

export default {
  name: 'ExpandedLayout',
  components: {
    BetslipBody,
    BetslipFooter,
  },
  data() {
    return {
      disabled: true,
    };
  },
  props: {
    payinDisabled: {
      type: Boolean,
      default: true,
    },
    theme: {
      type: String,
      default: 'dark',
    },
    bettingLocked: {
      type: Boolean,
      default: false,
    },
    bettingDisabled: {
      type: Boolean,
      default: false,
    },
    predefinedStakes: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.disabled = this.payinDisabled;
  },
};
</script>

<style scoped lang="scss">
.expanded-wrapper {
  width: 300px;
  background-color: var(--card-section);
  float: right;
}

@media (max-width: 661px) {
  .expanded-wrapper {
    .footer {
      display: none;
    }
  }
}

@media (min-width: 661px) {
  .expanded-wrapper {
    height: auto;
  }
}
</style>
